<template>
  <div class="container">
    <section>      
      <div class="container-fluid" style="margin-top:10px;">  
        <div class="row">    

          <div class="col-xs-12 col-sm-12 col-md-12">

              <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">

                  <!--List Area-->
                  <div class="list-area">

                    <PS/>

                  </div>
                </div>
              </div>
            
          </div>
        </div>
      </div>
    </section>

    <section class="">
      <div class="row">
      <div class="col-md-12 text-center">
        <p>
          Possui alguma dúvida? Entre em contato conosco, será um prazer lhes atender!
          <br>
          Nosso endereço abaixo é exclusivo para tirarmos quaisquer dúvidas que possam ter.
        </p>

        <a href="mailto:suporte@ibcgp.org.br?subject=Possuo uma dúvida, pode me ajudar?" class="mt-3 btn btn-main-sm btn-sm">suporte@ibcgp.org.br</a>
      </div>
    </div>
    </section>
  </div>
</template>

<script>
  import PS from './PS.vue';


  export default {
    components:{
      'PS'  : PS,
    }
  }
</script>

<style scoped>
</style>